import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=872e313a&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872e313a')) {
      api.createRecord('872e313a', component.options)
    } else {
      api.reload('872e313a', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=872e313a&", function () {
      api.rerender('872e313a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Admin.vue"
export default component.exports